<template>
  <div class="buymeister image-files-top-area">
    <div v-if="previewImage == null" class="buymeister image-files-preview-dummy">
      <span class="buymeister image-files-preview el-icon-picture-outline"></span>
    </div>
    <div v-else class="buymeister image-files-preview">
      <img class="buymeister image-files-preview" :src="previewImage">
    </div>
    <form style="display: none;">
      <input type="file" name="img_upload" id="image-files-selector" style="opacity: 0" @change="selectUploadFiles" multiple>
    </form>
    <draggable v-model="files" @end="fireChangeEvent()" draggable="div.bm-image-thumbnail" class="buymeister image-files-thumbnails">
      <template v-for="image in files">
        <image-thumbnail :src="image.url" :key="image.url" @remove="removeImage($event)" @select="selectImage($event)">
        </image-thumbnail>
      </template>
      <el-button
        v-if="files.length < 20"
        plain
        type="info"
        @click="openFileSelectDialog"
        icon="el-icon-plus"
        style="width: 46px; height: 46px; margin: 5px; padding: 0px; position: relative"
      >
      </el-button>
    </draggable>
  </div>
</template>

<script>
import api from '@/http/api.js'
import draggable from 'vuedraggable'
import ImageThumbnail from '@/components/ImageThumbnail.vue'

export default {
  name: 'ImageFiles',
  components: {
    draggable: draggable,
    imageThumbnail: ImageThumbnail
  },
  model: {
    prop: 'files',
    event: 'change'
  },
  props: {
    files: {
      type: Array
    }
  },
  data: function () {
    return {
      selectedImage: null
    }
  },
  computed: {
    previewImage: function () {
      if (this.selectedImage == null) {
        if (this.files == null || this.files.length <= 0) {
          return null
        } else {
          return this.getImageUrl(this.files[0].url)
        }
      } else {
        return this.getImageUrl(this.selectedImage)
      }
    }
  },
  methods: {
    getImageUrl: function (url) {
      return process.env.VUE_APP_IMG_ORIGIN + url
    },
    removeImage: function (src) {
      for (let idx = 0; idx < this.files.length; idx++) {
        if (src === this.files[idx].url) {
          this.files.splice(idx, 1)
          break
        }
      }
    },
    selectImage: function (src) {
      this.selectedImage = src
    },
    selectUploadFiles: async function (ev) {
      const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
      const filesSelector = document.getElementById('image-files-selector')
      const uploadFiles = filesSelector.files
      if (this.files.length + filesSelector.files.length > 20) {
        this.$message({
          message: '選択可能な画像個数の上限を超えています。(上限 20個)',
          type: 'error',
          duration: 2000
        })
        return
      }
      for (const uploadFile of uploadFiles) {
        const params = new FormData()
        params.append('upload_file', uploadFile)
        try {
          const uploadResult = await api.image.uploadImageFile(params)
          if (uploadResult.result === 'OK') {
            this.files.push({ url: uploadResult.path })
            this.$notify({
              title: 'アップロード成功',
              message: uploadFile.name + ': アップロードが完了しました。',
              type: 'success',
              duration: 1500
            })
          }
        } catch (e) {
          this.$notify({
            title: 'アップロード失敗',
            message: uploadFile.name + ': アップロードに失敗しました。',
            type: 'error',
            duration: 1500
          })
        }
        await sleep(200)
      }
      filesSelector.value = ''
      this.$emit('change', this.files)
    },
    fireChangeEvent: function () {
      this.$emit('change', this.files)
    },
    openFileSelectDialog: function () {
      const filesSelector = document.getElementById('image-files-selector')
      filesSelector.click()
    }
  }
}
</script>

<style>
div.buymeister.image-files-top-area {
  height: 50%;
  text-align: center;
}
div.buymeister.image-files-preview-dummy {
  display: block;
  width:  500px;
  height: 500px;
  position: relative;
  margin: 5px auto;
  background-color: silver;
}
span.buymeister.image-files-preview {
  position: absolute;
  top: 45%;
  left: 45%;
  font-size: 48px;
}
div.buymeister.image-files-preview {
  display: block;
  max-width:  500px;
  height: 500px;
  margin: 5px auto;
  border: 1px solid #d6d6d6
}
img.buymeister.image-files-preview {
  object-fit: contain;
  max-width:  490px;
  height: 490px;
}
div.buymeister.image-files-thumbnails {
  display: flex;
  flex-wrap: wrap;
  padding-right: 2px;
  width:  500px;
  margin: 5px auto;
}
</style>
